var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from "lit";
import { customElement, query, state } from "lit/decorators.js";
import { styles } from "../styles";
import "../profile/profile";
import "../app-switch/app-switch";
import "../search/search";
import "../notification-bell/notification-bell";
/**
 * The bender-components-container element. Integrates all webcomponents
 */
let ComponentsContainer = class ComponentsContainer extends LitElement {
    constructor() {
        super(...arguments);
        this.userRights = undefined;
    }
    render() {
        return html `
      <!-- Disable Notification Service and Search function P014-499 -->
      <!-- <bender-notification-bell></bender-notification-bell> -->
      <bender-app-switch .userRights=${this.userRights}></bender-app-switch>
      <!-- <bender-search></bender-search> -->
      <bender-profile></bender-profile>
    `;
    }
};
ComponentsContainer.styles = styles;
__decorate([
    query("bender-profile")
], ComponentsContainer.prototype, "profile", void 0);
__decorate([
    query("bender-app-switch")
], ComponentsContainer.prototype, "appSwitch", void 0);
__decorate([
    query("bender-search")
], ComponentsContainer.prototype, "search", void 0);
__decorate([
    query("bender-notification-bell")
], ComponentsContainer.prototype, "benderNotificationBell", void 0);
__decorate([
    state()
], ComponentsContainer.prototype, "userRights", void 0);
ComponentsContainer = __decorate([
    customElement("bender-components-container")
], ComponentsContainer);
export { ComponentsContainer };
//# sourceMappingURL=components-container.js.map